import { render, staticRenderFns } from "./created.vue?vue&type=template&id=08e295f6&scoped=true&"
import script from "./created.vue?vue&type=script&lang=js&"
export * from "./created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e295f6",
  null
  
)

export default component.exports